import { Component, OnInit, Input } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import * as angular from 'angular';
import { resolve } from 'url';
import { FormBuilder } from '@angular/forms';
import { PayGateService } from '../services/paygate.service';
import { CarrierService } from 'app/services/carrier.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { accounting } from 'accounting';
import { PopupService } from 'app/services/shared/popup.service';
import { ToastrService } from 'ngx-toastr';
import { retry } from 'rxjs/operator/retry';
import {ConfirmDialogService} from '../services/shared/confirm-dialog/confirm-dialog.service';

declare var $: any;

@Component({
  selector: 'app-account-deposit',
  templateUrl: './accountDeposit.component.html',
  styleUrls: ['./accountDeposit.component.css'] 
  
})
export class AccountDepositComponent implements OnInit {
  @Input() dataCntrl: any;
  @Input() isApproval: boolean = false;
  
  isLoading = false;
  message = "Loading. Please wait...";
  instructMsg = '';
  departuresList: any = [];
  departuresListRemove: any = [];
  editFlag: boolean = false;
  pageload: boolean = false;
  showBlock: boolean = false;
  payGateUrl:string = "https://secure.paygate.co.za/payweb3/process.trans";
  payReqId: string = "";
  checkSum: string = "";
  carrierid : any;
  Carrier : any;
  amountDisplay : any;
  amount:number;
  paymentRef: string = "";
  name: string = "";
  email: string = "";
  physical_address_1: string = "";
  physical_address_town : string = "";
  physical_post_code : string = "";

  checkoutForm = this.formBuilder.group({
    PAY_REQUEST_ID: '',
    CHECKSUM: ''
  });
  constructor(private formBuilder: FormBuilder, 
    private payGateService:PayGateService,
    private carrierService:CarrierService,
    private activeRoute: ActivatedRoute,
    private msgService: PopupService,
    private msg: ToastrService,private confirmDialogService: ConfirmDialogService,
    private router:Router) {}

  ngOnInit() {
    this.activeRoute.params.subscribe((params: Params) => {
    this.carrierid = params['id'];
    this.LoadCarrierAccountDetails();
    });

    
    
  }

  InitiatePayment()
  {
    if(!this.isFormValid())
    {
      return;
    }


    this.confirmDialogService.confirmThis('Are you sure you want to proceed to make payment?',
        () => {
          // this.onSwitchOnOrOff(true);

          this.message = "Please wait while we redirect you to our payment service..."
          this.isLoading = true;
          this.payGateService.AddTransaction(this.Carrier.carrier_account_id, this.amount.toString()).subscribe(transactionRef=>{

            var REFERENCE = this.paymentRef =  this.Carrier.carrier_account_id.toString() + '_' + transactionRef;
            var AMOUNT= this.amount.toString();
            var RETURN_URL= environment.payGateApi.returnUrl + REFERENCE;
            var EMAIL= this.Carrier.email;

            this.payGateService.InitiateTransaction(REFERENCE,AMOUNT,EMAIL,RETURN_URL).subscribe((res : any)=>{

              this.payReqId = res.PAY_REQUEST_ID;
              this.checkSum = res.CHECKSUM;

              if(this.payReqId != null && this.checkSum != null)
              {
                this.checkoutForm.patchValue({
                  PAY_REQUEST_ID:this.payReqId,
                  CHECKSUM:this.checkSum
                });

                let formSubmitBtn = document.getElementById("checkoutFormBtn");
                formSubmitBtn.click();

                this.isLoading = false;
                if(!environment.production)
                {
                  this.router.navigateByUrl('carrier/paymentcomplete/'+this.carrierid);
                }
              }
              else
              {
                this.isLoading = false;
                this.msg.error('Payment Gateway Error', 'Something went wrong, please try again...');
              }
            }, (error)=>{

              this.isLoading = false;
              this.msgService.showError('Payment Gateway Error', 'Something went wrong, please try again...', error);
            });
          });

        }, () =>  {
          //No here

        })

  }

  Goback(){
    this.router.navigateByUrl(`/carrier/permit/application/${this.carrierid}`);
  }

  CreditAccounInSage()
  {
    this.carrierService.processAccountCredit({id:this.carrierid, refNum:this.paymentRef, amnt:this.amount/100})
  }

  isFormValid() : boolean
  {
    if(this.amount == null || this.amount == undefined || this.amount === 0)
    {
      this.msg.error('No Amount', 'Please enter an amount');
      return false;
    }
    else return true;
  }

  formatCurrency(value) {
    return accounting.formatMoney(value, 'R', 2, ' ', '.');
  }

  LoadCarrierAccountDetails()
  {
    this.carrierService.getById(this.carrierid).subscribe(carrier=>{
      this.Carrier = carrier;
      console.log("carrier details" ,carrier);

      this.name = this.Carrier.name;
      this.email = this.Carrier.MainContact.EmailAddress;
      this.physical_address_1 = this.Carrier.physical_address_1;
      this.physical_address_town = this.Carrier.physical_address_town;
      this.physical_post_code = this.Carrier.physical_post_code;

    });
  }

  onSubmit(form: any, e: any): void {
    // Process checkout data here
    e.target.submit();
  }
  


  formatCurrency_TaxableValue(event)
  {      
    let inputAmount = Number.isNaN(Number(event.target.value))? 0 : Number(event.target.value);
    
    var uy = new Intl.NumberFormat('en-ZA',{style: 'currency', currency:'ZAR'}).format(inputAmount); 
    this.amount = inputAmount * 100;   
    if(inputAmount != 0)
    this.amountDisplay = uy;

    this.isFormValid();
  }
  
   isNumberKey(evt){
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
        return false;
    return true;
}
   
  backToTab() {
    
  }
}
